import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Voucher
      {record ? `: ${record.title}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Voucher/Title.js